// Icon.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';  // Icône pour les menus

const IconBars = ({ icon = faBars, size = '3x', color = '#f5721e' }) => {
  return <FontAwesomeIcon icon={icon} size={size} color={color} />;
};

export default IconBars;
